// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HF_u","content":"styles_content__1rGK6"};